<template>
  <div>
    <div class="row">
      <div class="col-md-3" :class="localCliente.id != null ? 'mb-2' : ''" v-if="localCliente.id != null">
        <label>Número de cliente</label>
        <input
          type="number"
          ref="numero_cliente"
          v-model="localCliente.numero"
          @input="
            localCliente.numero < 0 ? (localCliente.numero = 0) : null,
            actualizarCliente()
          "
          class="form-control text-right"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 mb-2" v-show="tieneAlias('Nombre')">
        <label>{{ cargarAliasCampo('Nombre') }}</label>
        <input
          class="form-control"
          ref="nombre_cliente"
          :placeholder="cargarAliasCampo('Nombre')+' del cliente'"
          @input="actualizarCliente()"
          v-model="localCliente.nombre"
        />
      </div>
      <div class="col-md-3 mb-2" v-show="tieneAlias('Apellido paterno')">
        <label>{{ cargarAliasCampo('Apellido paterno') }}</label>
        <input
          class="form-control"
          ref="apellido_paterno"
          :placeholder="cargarAliasCampo('Apellido paterno')+' del cliente'"
          @input="actualizarCliente()"
          v-model="localCliente.apellido_paterno"
        />
      </div>
      <div class="col-md-3 mb-2" v-show="tieneAlias('Apellido materno')">
        <label>{{ cargarAliasCampo('Apellido materno') }}</label>
        <input
          class="form-control"
          name="apellido_materno"
          :placeholder="cargarAliasCampo('Apellido materno')+' del cliente'"
          @input="actualizarCliente()"
          v-model="localCliente.apellido_materno"
        />
      </div>
      <div class="col-md-3 mb-2" v-show="tieneAlias('RFC')">
        <label>{{ cargarAliasCampo('RFC') }}</label>
        <input 
          class="form-control" name="rfc"
          v-model="localCliente.rfc"
          :placeholder="cargarAliasCampo('RFC')+' del cliente'"
          @input="actualizarCliente()"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 mb-2" v-show="tieneAlias('Sexo')">
        <label>{{ cargarAliasCampo('Sexo') }}</label>
        <select 
          class="form-select" name="sexo" 
          v-model="localCliente.sexo" 
          @change="actualizarCliente()"
        >
          <option value="hombre">Hombre</option>
          <option value="mujer">Mujer</option>
        </select>
      </div>
      <div class="col-md-3 mb-2" v-show="tieneAlias('Tipo de cliente')">
        <label>{{ cargarAliasCampo('Tipo de cliente') }}</label>
        <select
          class="form-select" name="empresa"
          v-model="localCliente.empresa"
          @change="actualizarCliente()"
        >
          <option :value="0">Persona</option>
          <option :value="1">Empresa</option>
        </select>
      </div>
      <div class="col-md-1 mb-2" v-show="tieneAlias('Estado')">
        <label>{{ cargarAliasCampo('Estado') }}</label> <br />
        <span
          class="badge font-size-15"
          :class="{
            'bg-success': localCliente.activo,
            'bg-danger': !localCliente.activo
          }"
        >
          {{ localCliente.activo ? 'Activo' : 'Retirado' }}
        </span>
      </div>
      <div class="col-md-5 mb-2">
        <label>
          Etiquetas
          <button class="btn btn-soft-dark btn-sm pb-0 pt-0 ms-2"
            ref="mostrarRoles"
            @click="mostrarMdlEtiquetas()">
            <i class="mdi mdi-plus-thick"></i>
          </button>
        </label>
        <div style="display: flex; flex-wrap: wrap; gap: 5px;">
          <span 
            v-for="(etiqueta, index) in cliente.etiquetas" 
            :key="etiqueta.id"
            class="badge"
            :title="etiqueta.nombre"
            style="
              width: 18%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 5px;
            "
            :style="{
              backgroundColor: etiqueta.color,
              color: colorIdealTexto(etiqueta.color)
            }"
          >
            <span
              style="
                overflow: hidden; text-overflow: ellipsis;
                white-space: nowrap; flex: 1; min-width: 0;
              "
            >
              {{ etiqueta.nombre }}
            </span>
            <a 
              href="#" 
              @click.prevent="quitarEtiqueta(index)"
              :style="{
                color: colorIdealTexto(etiqueta.color),
                flex: '0 0 auto'
              }"
            >
              <i class="mdi mdi-close"></i>
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="mb-2" v-show="tieneAlias('Nota')">
      <label>{{ cargarAliasCampo('Nota') }}</label>
      <textarea
        class="form-control"
        name="nota" rows="5"
        v-model="localCliente.nota"
        :placeholder="cargarAliasCampo('Nota')+' del cliente'"
        @input="actualizarCliente()"
      ></textarea>
    </div>

    <mdl-etiquetas
      ref="mdlEtiquetas"
      :cliente="cliente"
      @actualizar:cliente="actualizarLocalCliente($event)"
      @actualizar:etiqueta:cliente="actualizarEtiquetaCliente"
      @eliminar:etiqueta:cliente="eliminarEtiquetaCliente"
    ></mdl-etiquetas>
  </div>
</template>

<script>
import MdlEtiquetas from './MdlEtiquetas.vue';

export default {
  name: 'CmpGeneral',
  props: ["cliente", "tieneAlias", "cargarAliasCampo"],
  components: {
    MdlEtiquetas
  },
  data() {
    return {
      localCliente: {}
    }
  },
  watch: {
    cliente: {
      deep: true,
      immediate: true,
      handler(val) {
        this.localCliente = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    actualizarCliente: function() {
      var self = this
      self.$emit("update:cliente", JSON.parse(JSON.stringify(this.localCliente)))
    },

    actualizarLocalCliente: function(event) {
      var self = this
      self.localCliente = event
      this.actualizarCliente()
    },

    actualizarEtiquetaCliente(event) {
      this.$emit("actualizar:etiqueta:cliente", event)
    },

    eliminarEtiquetaCliente(event) {
      this.$emit("eliminar:etiqueta:cliente", event)
    },
  
    mostrarMdlEtiquetas: function() {
      var self = this
      self.$refs.mdlEtiquetas.mostrar()
    },

    quitarEtiqueta: function(index) {
      self = this
      self.localCliente.etiquetas.splice(index, 1)
      self.actualizarCliente()
    },

    colorIdealTexto: function(hexColor) {
      let limite = 105
      let componentes = {
        r: parseInt( hexColor.substring(1,3), 16),
        g: parseInt( hexColor.substring(3,5), 16),
        b: parseInt( hexColor.substring(5,7), 16)
      }

      let bgDelta = (componentes.r * 0.299) + (componentes.g * 0.587) + (componentes.b * 0.114);
      
      return ((255 - bgDelta) < limite) ? "#000000" : "#ffffff";
    },
  }
}
</script>

<style scoped>
</style>